import React from "react";

import { T } from "services/lang/LanguageService";
import CalendarWrapper from "../calendar-wrapper/CalendarWrapper";

type DateTimeRangeProps = {
  dateFrom?: Date;
  dateTo?: Date;
  invalidRange?: boolean;
  selectDateFrom: (date: Date) => void;
  selectDateTo: (date: Date) => void;
};

const DateTimeRange: React.FC<DateTimeRangeProps> = ({
  dateFrom,
  dateTo,
  invalidRange = false,
  selectDateFrom,
  selectDateTo,
}) => {
  return (
    <>
      <div className="flex flex-column">
        {!invalidRange && <label htmlFor="datetimeFrom">{T("word.date-from")}:</label>}
        {invalidRange && <p className="error">{T("error.datetime-range-selector.must-be-before-to-date")}</p>}
        <CalendarWrapper id="datetimeFrom" value={dateFrom} onChange={selectDateFrom} />
      </div>
      <div className="flex flex-column">
        {!invalidRange && <label htmlFor="datetimeTo">{T("word.date-to")}:</label>}
        {invalidRange && <p className="error">{T("error.datetime-range-selector.must-be-after-from-date")}</p>}
        <CalendarWrapper id="datetimeTo" value={dateTo} onChange={selectDateTo} />
      </div>
    </>
  );
};

export default DateTimeRange;
